/* eslint-disable no-param-reassign,consistent-return */
/**
 * Created by IvanCai on 2017/4/19.
 */
import axios from 'axios';
import utils from '../utils';
import baseURL from '@/configs/baseUrl'
import router from '@/router/index'

const dkAxiosFile = axios.create({
  baseURL,
  timeout: 100000, // 设置超时时间
});

// eslint-disable-next-line

let time = null
dkAxiosFile.interceptors.request.use(
  (config) => {
    if (!time) {
      time = setTimeout(() => {
        window.showLoading()
      }, 1000);
    }

    const token = utils.getCookie('token')
    config.headers = { 'X-Access-Token': token || ''}
    return config;
  },
  error => Promise.reject(error),
);


dkAxiosFile.interceptors.response.use(
  response => {
    window.hideLoading();
    if (time) {
      clearTimeout(time)
      time = null
    }
    return response;
  },
  (error) => {
    window.hideLoading();
    if (time) {
      clearTimeout(time)
      time = null
    }
    const { status, data } = error.response;
    switch (status) {
      case 401:
        router.push('/login');
        break;
      case 403:
        window.toast(data.error.message)
        return error.response
      case 412:
        break;
      default:
        window.toast(data.error.message)
        return Promise.reject(data);
    }
  },
);
export default dkAxiosFile;
